import type {
  AnnuaireSanteProfessional,
  StructuredValue,
} from '../types/structuredValue';

/** `{titre} {prénom} {NOM} à {ville}` – no article; name alone when no city. */
export const formatAnnuaireSanteProfessional = (
  p: AnnuaireSanteProfessional,
): string => {
  const name = [p.title, p.firstName, p.lastName].filter(Boolean).join(' ');
  return p.city ? `${name} à ${p.city}` : name;
};

const FORMATTERS: {
  [K in StructuredValue['kind']]: (
    value: Extract<StructuredValue, { kind: K }>,
  ) => string;
} = {
  ANNUAIRE_SANTE_PROFESSIONAL: formatAnnuaireSanteProfessional,
};

/** Only kinds with a formatter pass, so an unknown `kind` never reaches `formatStructuredValue`. */
export const isStructuredValue = (value: unknown): value is StructuredValue =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as { kind?: unknown }).kind === 'string' &&
  Object.prototype.hasOwnProperty.call(
    FORMATTERS,
    (value as { kind: string }).kind,
  );

export const formatStructuredValue = (value: StructuredValue): string =>
  FORMATTERS[value.kind](value);
